/**
 * @module SendInvoice
 */

import axios from 'api/axios'

class SendInvoiceHelper {
  /**
   * @async
   * @param {Object} invoice - The options for submitting invoice data.
   * @param {string} invoice.Base64_xml_file - This is base64 xml file
   * @param {string} invoice.Xml_filename
   * @param {string} invoice.Base64_pdf_file
   * @param {string} invoice.Pdf_fillename
   * @param {string} invoice.Id_entrada
   * @param {string} invoice.Id_detalle
   * @param {Array<string>} invoice.order_lines_ids
   * @returns {Promise<any>}
   */
  static async createInvoice({
    base64_xml_file,
    xml_filename,
    base64_pdf_file,
    pdf_filename,
    id_entrada,
    id_detalle,
    order_lines_ids,
  }) {
    try {
      return axios.post(`efactura/purchaseorder/createinvoice/`, {
        base64_xml_file,
        xml_filename,
        base64_pdf_file,
        pdf_filename,
        id_entrada,
        id_detalle,
        order_lines_ids,
      })
    } catch (error) {
      throw new Error(error.message)
    }
  }
}

export default SendInvoiceHelper
